export default __webpack_public_path__ + "static/media/pairing.ed545f30.png";